import { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyFetch } from "../../App";
import { useNavigate } from 'react-router-dom';
import Button from "react-bootstrap/esm/Button";

const ClientList = (props) => {
    const [list_Data, set_List_Data] = useState([])
    const navigate=useNavigate()

    useEffect(() => {
        MyFetch("https://easytasks.in/client/list", {}, "GET")
            .then((res) => res.json())
            .then((data) => set_List_Data(data));
    }, [])

    const renderClient = (client, index) => {
        return (
            <tr key={index}>
                <td>{index}</td>
                <td>{client.name}</td>
                <td>{client.mobile}</td>
                <td>{client.email}</td>
                <td>{client.city}</td>
                <td><Button variant="outline-secondary" onClick={()=>navigate('/client/edit',{state:{clientid:client.id}})}>Edit</Button></td>
            </tr>
        )
    };

    return (
        <Container className='mt-5'>
            <Row className="justify-content-md-left">
                <Col xs lg="5" >
                    <h2 className='my-5'><b>VIEW ALL CLIENTS</b></h2>
                </Col>
            </Row>
            <Table striped bordered hover size='sm'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>City</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                {list_Data && list_Data.length > 0 ? list_Data.map(renderClient) : <></>}
                {/* {console.log(list_Data)} */}
                </tbody>
            </Table>
        </Container>
    )
}

export default ClientList;